<template>
  <div class="flex w-full flex-col items-center gap-3 text-center">
    <TitleMedium v-html="$t('upsell.not_included')" />
    <slot name="guidance_text">
      <p v-html="feature_guidance_text" />
    </slot>
    <slot name="button">
      <ButtonUpsell :feature="feature" />
    </slot>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ButtonUpsell from '@/app/_employees/components/ButtonUpsell.vue';

const props = defineProps({
  feature: { type: String, required: true },
});

const { t } = useI18n();

const feature_guidance_text = computed(() => t(`upsell.${props.feature}.guidance`));
</script>
